import React from 'react';
import { Box, Button, IconButton, Snackbar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

/** "Widget poistettu: X · Kumoa" toast, bottom-left, 6 s, restarted on each removal. */
export default function UndoSnackbar({ removed, onUndo, onClose }) {
  const { t } = useTranslation();
  const title = removed ? t(`dashboard.widgets.${removed.widget.id}.title`) : '';
  return (
    <Snackbar
      key={removed?.token || 'none'}
      open={Boolean(removed)}
      autoHideDuration={6000}
      onClose={(event, reason) => {
        if (reason === 'clickaway') return;
        onClose();
      }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    >
      <Box data-testid="widget-undo-toast" sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 2, py: 1.25, bgcolor: '#1a365d', color: '#fff', borderRadius: '10px', boxShadow: '0 8px 24px rgba(15,35,64,.35)', fontSize: 14 }}>
        <span>{t('dashboard.edit.removed', { title })}</span>
        <Button data-testid="widget-undo" size="small" onClick={onUndo} sx={{ color: '#63b3ed', fontWeight: 600, minWidth: 0 }}>
          {t('dashboard.edit.undo')}
        </Button>
        <IconButton size="small" onClick={onClose} sx={{ color: 'rgba(255,255,255,.7)' }}>
          <CloseIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Box>
    </Snackbar>
  );
}
